/** The ten national digits of a US number, or '' when it is not one. */
const nationalDigits = (phone?: string | null): string => {
   const digits = (phone || '').replace(/\D/g, '')
   if (digits.length === 10) return digits
   if (digits.length === 11 && digits.startsWith('1')) return digits.slice(1)
   return ''
}

/** "+17195550100" → "(719) 555-0100"; anything else is returned as given. */
export const prettyPhone = (phone?: string | null): string => {
   const national = nationalDigits(phone)
   if (!national) return phone || ''
   return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`
}

/** Preserve location searches; strip formatting only from phone-number input. */
export const numberSearch = (value: string) => {
   const text = value.trim().replace(/\s+/g, ' ')
   if (!text || /[a-z]/i.test(text)) return text
   const digits = text.replace(/\D/g, '')
   return /^1\d{3}$/.test(digits) ? digits.slice(1) : digits
}
